var map = {
	"./approved.png": "+GtZ",
	"./create.png": "5Wk2",
	"./sent.png": "VKDn",
	"./submit.png": "Ptko"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "WsDO";


//////////////////
// WEBPACK FOOTER
// ./src/assets/document ^\.\/.*\.png$
// module id = WsDO
// module chunks = 1